import { addTranslation } from "media-chrome/utils/i18n";

export const Vi = {
  "Start airplay": "Bắt đầu AirPlay",
  "Stop airplay": "Dừng AirPlay",
  Audio: "Âm thanh",
  Captions: "Phụ đề",
  "Enable captions": "Bật phụ đề",
  "Disable captions": "Tắt phụ đề",
  "Start casting": "Bắt đầu truyền phát",
  "Stop casting": "Dừng truyền phát",
  "Enter fullscreen mode": "Chế độ toàn màn hình",
  "Exit fullscreen mode": "Thoát chế độ toàn màn hình",
  Mute: "Tắt tiếng",
  Unmute: "Bật tiếng",
  "Enter picture in picture mode": "Chế độ hình trong hình",
  "Exit picture in picture mode": "Thoát chế độ hình trong hình",
  Play: "Phát",
  Pause: "Tạm dừng",
  "Playback rate": "Tốc độ phát",
  "Playback rate {playbackRate}": "Tốc độ phát {playbackRate}",
  Quality: "Chất lượng",
  "Seek backward": "Lùi lại",
  "Seek forward": "Tua tới",
  Settings: "Cài đặt",
  "audio player": "trình phát âm thanh",
  "video player": "trình phát video",
  volume: "âm lượng",
  seek: "tua",
  "closed captions": "phụ đề chi tiết",
  "current playback rate": "tốc độ phát hiện tại",
  "playback time": "thời gian phát",
  "media loading": "đang tải nội dung",

  settings: "cài đặt",
  "audio tracks": "các bản âm thanh",
  quality: "chất lượng",
  play: "phát",
  pause: "tạm dừng",
  mute: "tắt tiếng",
  unmute: "bật tiếng",
  live: "trực tiếp",
  "start airplay": "bắt đầu AirPlay",
  "stop airplay": "dừng AirPlay",
  "start casting": "bắt đầu truyền phát",
  "stop casting": "dừng truyền phát",
  "enter fullscreen mode": "chế độ toàn màn hình",
  "exit fullscreen mode": "thoát chế độ toàn màn hình",
  "enter picture in picture mode": "chế độ hình trong hình",
  "exit picture in picture mode": "thoát chế độ hình trong hình",
  "seek to live": "tua đến trực tiếp",
  "playing live": "đang phát trực tiếp",
  "seek back {seekOffset} seconds": "lùi lại {seekOffset} giây",
  "seek forward {seekOffset} seconds": "tua tới {seekOffset} giây",

  "Network Error": "Lỗi mạng",
  "Decode Error": "Lỗi giải mã",
  "Source Not Supported": "Nguồn không được hỗ trợ",
  "Encryption Error": "Lỗi mã hóa",
  "A network error caused the media download to fail.":
    "Lỗi mạng khiến việc tải nội dung thất bại.",
  "A media error caused playback to be aborted. The media could be corrupt or your browser does not support this format.":
    "Lỗi nội dung khiến việc phát bị hủy. Nội dung có thể bị lỗi hoặc trình duyệt không hỗ trợ định dạng này.",
  "An unsupported error occurred. The server or network failed, or your browser does not support this format.":
    "Xảy ra lỗi không được hỗ trợ. Máy chủ hoặc mạng bị lỗi, hoặc trình duyệt không hỗ trợ định dạng này.",
  "The media is encrypted and there are no keys to decrypt it.":
    "Nội dung đã bị mã hóa và không có khóa để giải mã.",
};

addTranslation("vi", Vi);
